import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

export const SIDEBAR_OPEN_QUERY_PARAM = 'sidebarOpen';

@Injectable({
  providedIn: 'root',
})
export class MobileSidebarService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  private checkIfSet(): boolean {
    const urlTree = this.router.parseUrl(this.router.url);
    return !!urlTree.queryParams[SIDEBAR_OPEN_QUERY_PARAM];
  }

  private checkIfOpened(): boolean {
    const urlTree = this.router.parseUrl(this.router.url);
    return urlTree.queryParams[SIDEBAR_OPEN_QUERY_PARAM] === 'true';
  }

  public readonly isQueryParamSet = toSignal(
    this.router.events.pipe(map(() => this.checkIfSet())),
    { initialValue: this.checkIfSet() },
  );

  // Convert the observable to a signal for reactive usage
  public readonly isOpened = toSignal(
    this.router.events.pipe(map(() => this.checkIfOpened())),
    { initialValue: this.checkIfOpened() },
  );

  public async open(): Promise<boolean> {
    return this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [SIDEBAR_OPEN_QUERY_PARAM]: true },
      queryParamsHandling: 'merge',
    });
  }

  public async close(): Promise<boolean> {
    // Set sidebarOpen to null to remove it from query params
    return this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [SIDEBAR_OPEN_QUERY_PARAM]: null },
      queryParamsHandling: 'merge',
    });
  }

  public async toggle(): Promise<boolean> {
    if (this.isOpened()) {
      return this.close();
    } else {
      return this.open();
    }
  }
}
